import React, { Component } from 'react';
import InnerHTML from 'dangerously-set-html-content';
import './footer.css';
import './socialmedia.css';
import axios from 'axios';
import envConfig from 'env/EnvConfig';

class FooterWidget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: '',
        };
    }

    componentDidMount() {
        this.loadData(`${envConfig.ENV_URL}/vcm-experience-fragments/vcm-footer/master.html`);
    }

    loadData = url => {
        delete axios.defaults.headers.common['x-api-key'];
        axios
            .get(url, { headers: { Authorization: `${envConfig.PRELOGIN_HEADER_AUTH}` }, timeout: 40000 })
            .then(response => {
                if (response) {
                    return response.data;
                }
                throw new Error('Error message.');
            })
            .then(data => {
                let result = data.toString();
                result = result.replace(/<script[^>]*>/gi, ' <!-- ');
                result = result.replace(/<\/script>/gi, ' --> ');
                result = result.replace(/href="\//g, `href="${envConfig.ENV_URL}/`);
                result = result.replace(/\/etc/g, `${envConfig.ENV_URL}/etc`);
                result = result.replace(/\/content/g, `${envConfig.ENV_URL}/content`);
                this.setState({ content: result });
            })
            .catch(err => {
                console.log('failed to load footer', url, err.message);
            });
    };

    render() {

        return (
            <vcm-footer id="vcm-foot" role="contentinfo">
                {' '}
                <InnerHTML html={this.state.content} />{' '}
            </vcm-footer>
        );
    }
}

export default FooterWidget;
